// icons
import menuOpen from "./images/menu-icon.svg";
import menuClose from "./images/menu-close.svg";

// Display year in the footer using Date
const footerYear = document.getElementById("copyrightYear");
let d = new Date();

footerYear.textContent = d.getFullYear();

// Navigation functionality
const navToggleButton = document.getElementById("navToggleButton");
const navBarLinks = document.getElementById("navbarLinks");
const menuToggleIcon = document.querySelector("#menuToggleIcon");
let hidden = true;

navToggleButton.addEventListener("click", () => {
  if (hidden) {
    // navToggleButton.classList.add("nav__toggle-focus");
    navBarLinks.classList.add("nav__links-show");
    menuToggleIcon.setAttribute("src", menuClose);
    hidden = false;
  } else {
    // navToggleButton.classList.remove("nav__toggle-focus");
    navBarLinks.classList.remove("nav__links-show");
    menuToggleIcon.setAttribute("src", menuOpen);
    hidden = true;
  }
});
